/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DealerUserDTO, ResetPasswordDTO, UserDTO } from '../models/UserDTO';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
import { RemoteSelectOption } from 'src/types';

export class UserControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) { }

    /**
     * @returns UserDTO OK
     * @throws ApiError
     */
    public getRegisterUsers(): CancelablePromise<Array<UserDTO>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/register/users',
            errors: {
                401: `Not Authorized`,
                403: `Not Allowed`,
            },
        });
    }

    /**
     * @returns UserDTO OK
     * @throws ApiError
     */
    public getRegisterUsersSegnalatore(): CancelablePromise<Array<UserDTO>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/register/users/segnalatore',
            errors: {
                401: `Not Authorized`,
                403: `Not Allowed`,
            },
        });
    }

    /**
    * GET all users that have SALES role
    * @returns UserDTO OK
    * @throws ApiError
    */
    public getRegisterSales(): CancelablePromise<Array<UserDTO>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/register/users/fleetmanager-association',
            errors: {
                401: `Not Authorized`,
                403: `Not Allowed`,
            },
        });
    }

    /**
  * @returns UserDTO OK
  * @throws ApiError
  */
    public getFleetManagerAssociatedSales(username: string): CancelablePromise<Array<UserDTO>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/register/users/{username}/fleetmanager',
            path: {
                'username': username,
            },
            errors: {
                401: `Not Authorized`,
                403: `Not Allowed`,
            },
        });
    }


    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public postRegisterUsers(
        requestBody?: UserDTO,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/register/users',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Not Authorized`,
                403: `Not Allowed`,
            },
        });
    }

    /**
     * @param username
     * @returns UserDTO OK
     * @throws ApiError
     */
    public getRegisterSingleUser(
        username: string,
    ): CancelablePromise<UserDTO> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/register/users/{username}',
            path: {
                'username': username,
            },
            errors: {
                401: `Not Authorized`,
                403: `Not Allowed`,
            },
        });
    }

    /**
     * @param username
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public putRegisterUsers(
        username: string,
        requestBody?: UserDTO,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/register/users/{username}',
            path: {
                'username': username,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Not Authorized`,
                403: `Not Allowed`,
            },
        });
    }

    /**
     * @param username
     * @returns void
     * @throws ApiError
     */
    public deleteRegisterUsers(
        username: string,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/register/users/{username}',
            path: {
                'username': username,
            },
            errors: {
                401: `Not Authorized`,
                403: `Not Allowed`,
            },
        });
    }

    /**
    * GET all users that have SALES role by dealer
    * @returns UserDTO OK
    * @throws ApiError
    */
    public getReporterSalesByDealer(dealer: string): CancelablePromise<Array<UserDTO>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/register/users/segnalatore/responsabili',
            query: { dealer },
            errors: {
                401: `Not Authorized`,
                403: `Not Allowed`,
            },
        });
    }

    /**
    * GET all reporter dealers
    * @returns RemoteSelectOption OK
    * @throws ApiError
    */
    public getReporterDealers(): CancelablePromise<Array<RemoteSelectOption>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/register/users/segnalatore/dealers',
            errors: {
                401: `Not Authorized`,
                403: `Not Allowed`,
            },
        });
    }

    /**
     * @param username
     * @returns void
     * @throws ApiError
     */
    public approveUser(
        username: string,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/register/users/{username}/enable',
            path: { username },
            query: { enabled: true },
            errors: {
                401: `Not Authorized`,
                403: `Not Allowed`,
            },
        });
    }

    /**
     * @param username
     * @returns void
     * @throws ApiError
     */
    public rejectUser(
        username: string,
        reason: string,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/register/users/{username}/enable',
            path: { username },
            query: { enabled: false, message: reason },
            errors: {
                401: `Not Authorized`,
                403: `Not Allowed`,
            },
        });
    }

    /**
     * @param username
     * @returns void
     * @throws ApiError
     */
    public requestApproval(
        username: string,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/register/users/{username}/enable',
            path: { username },
            query: { enabled: false, requestApproval: true },
            errors: {
                401: `Not Authorized`,
                403: `Not Allowed`,
            },
        });
    }

    public removeAlert(
        username: string,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/register/users/{username}/alert/remove',
            path: { username },
            query: {},
            body: {},
            errors: {
                401: `Not Authorized`,
                403: `Not Allowed`,
            },
        });
    }

    /**
     * @returns UserDTO OK
     * @throws ApiError
     */
    public getBackofficeUsers(): CancelablePromise<Array<UserDTO>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/register/users/backoffices',
            errors: {
                401: `Not Authorized`,
                403: `Not Allowed`,
            },
        });
    }

    public getDealersUsers(): CancelablePromise<Array<DealerUserDTO>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/register/users/dealers',
            errors: {
                401: `Not Authorized`,
                403: `Not Allowed`,
            },
        });
    }

    public resetPassword(
        username: string,
    ): CancelablePromise<ResetPasswordDTO> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/register/users/{username}/resetpw',
            path: { username },
            query: {},
            body: {},
            errors: {
                401: `Not Authorized`,
                403: `Not Allowed`,
            },
        });
    }
}
